import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

import Icon from "../../elements/Icon";
import Text from "../../elements/Text";

import Tile from "./elements/Tile";

const CustomTile = styled(Tile)`
  background-color: ${select.color(["grey", 0])};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: hsl(120, 3%, 94%);
  }
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  label: string;
  onClick?: () => void;
};

function AddTile({ style, className, onClick, label }: Props, ref: any) {
  return (
    <CustomTile ref={ref} style={style} className={className} onClick={onClick}>
      <Inner>
        <Icon
          c={["grey", 6]}
          size={48}
          name="add"
          style={{ marginBottom: 8 }}
        />
        <Text fw={"bold"} c={["grey", 6]}>
          {label}
        </Text>
      </Inner>
    </CustomTile>
  );
}

export default React.forwardRef(AddTile);
